export const openDeeplink = (url) => {
  const normalized = String(url ?? "").trim();
  const lower = normalized.toLowerCase();

  if (lower.startsWith("http://") || lower.startsWith("https://")) {
    window.open(normalized, "_blank", "noopener,noreferrer");
  }
};
